// JS-side mirror of the icons declared in `src/pug/mixins/_icons.pug`.
// The Pug `+icon('name')` mixin can't be called from JS, so any DOM
// built at runtime (recipient cards, accordion chevrons, etc.) reaches
// for these SVG strings instead. Keep the path data here in sync with
// the Pug mixin — visual changes need to land in both places.
//
// Consumers can either `innerHTML`-swap a pre-rendered `.icon.icon--ui`
// wrapper (toggle pattern) or call `iconNode(SVG)` to mint a fresh
// wrapper + SVG together (build pattern).

export const CHEVRON_DOWN = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M10 10.6031L13.0633 7.5L14 8.44799L10 12.5L6 8.44799L6.93668 7.5L10 10.6031Z" fill="currentColor"/></svg>`;
export const CHEVRON_UP   = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M10 9.39685L13.0633 12.5L14 11.552L10 7.5L6 11.552L6.93668 12.5L10 9.39685Z" fill="currentColor"/></svg>`;
export const CLOSE_SM     = `<svg width="8" height="8" viewBox="6 6 8 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.99996 9.29649L13.2964 6L14 6.70354L10.7035 10L13.9999 13.2964L13.2964 14L9.99996 10.7036L6.70359 13.9999L6.00004 13.2964L9.29638 10L6 6.70364L6.70355 6.0001L9.99996 9.29649Z" fill="currentColor"/></svg>`;

// Mint a new `<span class="icon icon--<variant>">` wrapping the given
// SVG markup, matching what the Pug `+icon` mixin emits server-side.
// Use when constructing DOM from scratch (the toggle path can keep
// using innerHTML on a pre-rendered wrapper).
export function iconNode(svg, variant = 'ui') {
  const span = document.createElement('span');
  span.className = `icon icon--${variant}`;
  span.setAttribute('aria-hidden', 'true');
  span.innerHTML = svg;
  return span;
}
